import { Grid2 } from '@mui/material'
import FormSingleColumnLayout from '../../../layouts/form-single-column-layout/form-single-column-layout'
import TextInputField from '../../fields/text-input-field/text-input-field.component'
import AutocompleteAddressField from '../../fields/autocomplete-address-field/autocomplete-address-field.component'

const DropAddressForm = () => {
  return (
    <form autoComplete="off">
      <Grid2 container spacing={2}>
        <FormSingleColumnLayout>
          <AutocompleteAddressField
            label="Address line 1*"
            name="addressLine1"
            placeholder=""
          />
        </FormSingleColumnLayout>

        <FormSingleColumnLayout>
          <TextInputField label="Address line 2" name="addressLine2" placeholder="" autoComplete="off" />
        </FormSingleColumnLayout>

        <FormSingleColumnLayout>
          <TextInputField label="City*" name="city" placeholder="" autoComplete="off" />
        </FormSingleColumnLayout>

        <FormSingleColumnLayout>
          <TextInputField label="Province*" name="province" placeholder="" autoComplete="off" />
        </FormSingleColumnLayout>

        <FormSingleColumnLayout>
          <TextInputField label="Postal code*" name="postalCode" placeholder="" autoComplete="off" />
        </FormSingleColumnLayout>
      </Grid2>
    </form>
  )
}

export default DropAddressForm
